import React from "react";
import { compose, graphql } from "react-apollo";
import { withQuery } from "containers/withQuery";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import SensorModal from "./SensorModal";
import { SENSOR_QUERY, SENSORS_QUERY } from "../generalRegisterQueries";
import { UPDATE_SENSOR_MUTATION } from "../generalRegisterMutations";

const SensorEdit = ({
  sensor,
  id,
  updateSensor,
  snackbarContext,
  onFinishEdit,
}) => {
  const onSave = (updatedSensor) => {
    updateSensor({
      variables: {
        id,
        params: updatedSensor
      },
      refetchQueries: [{
        query: SENSORS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Sensor atualizado.");
        onFinishEdit();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <SensorModal
      toggleModal={onFinishEdit}
      isOpen={id !== null}
      onSave={onSave}
      {...sensor}
      title="Editar sensor"
    />
  );
};

export default compose(
  withQuery(({ id }) => ({
    query: SENSOR_QUERY,
    variables: {
      id,
    },
    noLoader: true,
  })),
  graphql(UPDATE_SENSOR_MUTATION, { name: "updateSensor", }),
  withSnackbarConsumer,
)(SensorEdit);
